<template>
  <div>
    <el-select
      :style="styles"
      v-model="val"
      filterable
      :multiple="multiple"
      :placeholder="placeholder"
      :disabled="disabled"
      clearable
      @change="handlerChange"
    >
      <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
  </div>
</template>

<script>
  import { transFormDataType } from '../utils'
  export default {
    name: 'ComCommonSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      styles: {
        type: Object,
        default: () => {}
      },
      options: {
        type: Array,
        require: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        val: undefined
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      }
    },
    computed: {
      list() {
        const arr = []
        if (this.options && this.options.length) {
          this.options.forEach((it) => {
            arr.push({
              label: it.label,
              value: it.value + ''
            })
          })
        }
        return arr
      }
    },
    methods: {
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item.value)
        this.$emit('change', item)
      }
    }
  }
</script>

<style lang="scss" scoped></style>
